import MDPhoneInput from "../components/Inputs/MDPhoneInput";
import { Form, Formik } from "formik";
import MDTextInput from "../components/Inputs/MDTextInput";
import MDSelectInput from "../components/Inputs/MDSelect";
import MDDateAndTimePicker from "../components/Inputs/MDDateAndTimePicker";
import AutoFocusError from "../components/AutoFocusError";
import { SellerStep1Schema, SellerStep5Schema } from "../validations";
import { useRef, useState } from "react";
import {
  buyerHomeTypeOptions,
  buyerSincerityOptions,
  leadsLookingOptions,
} from "../utils/enum";
import axios from "axios";
import { useLocation } from "react-router";
import dayjs from "dayjs";
import MDAutoComplete from "../components/Inputs/MDAutoComplete";
import { config } from "../utils/config";
import LeadReferralGenericThanks from "../components/ThanksUser/LeadReferralGenericThanks";
import FormFirstSlide from "../components/FormFirstSlide";

const LeadReferralRewardsGenericForm = ({ isMultiPartForm }) => {
  const typingTimeout = useRef(null);
  const [currentStep, setCurrentStep] = useState(isMultiPartForm ? 2 : 1);
  const [isWhatsApp, setIsWhatsApp] = useState(false);
  const [addressOptions, setAddressOptions] = useState([]);
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [phoneBtnClick, setPhoneBtnClick] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [submitError, setSubmitError] = useState(false);

  const userAddress = queryParams.get("address");
  const windowUrl = window.location.href;
  const marketingSource = queryParams.get("source");

  const handleAddressChange = async (event, value) => {
    const inputValue = value.trimStart();
    if (inputValue.length > 0) {
      if (typingTimeout.current) {
        clearTimeout(typingTimeout.current);
      }

      typingTimeout.current = setTimeout(async () => {
        try {
          const headers = {
            "Content-Type": "application/json",
          };

          const response = await axios.get(
            `https://config.needhome.ca/api/Data/AddressResponse/${value}`,
            headers
          );

          if (response?.data?.result === 1) {
            const filteredCities = response?.data?.data?.reduce((acc, item) => {
              const exists = acc.find(
                (i) => i.responseDesc === item.responseDesc
              );
              if (!exists) {
                acc.push({
                  responseTitle: item.responseTitle,
                  responseDesc: item.responseDesc,
                });
              }
              return acc;
            }, []);
            setAddressOptions(filteredCities);
          }
        } catch (error) {
          console.log(error);
        }
      }, 300);
    }
  };

  const handleCityChange = async (event, value) => {
    const inputValue = value.trimStart();
    if (inputValue.length > 0) {
      if (typingTimeout.current) {
        clearTimeout(typingTimeout.current);
      }

      typingTimeout.current = setTimeout(async () => {
        try {
          const headers = {
            "Content-Type": "application/json",
          };

          const response = await axios.get(
            `https://config.needhome.ca/api/Data/AddressResponse/${value}`,
            headers
          );

          if (response?.data?.result === 1) {
            const filteredCities = response?.data?.data?.reduce((acc, item) => {
              const exists = acc.find(
                (i) => i.responseTitle === item.responseTitle
              );
              if (!exists) {
                acc.push({
                  responseTitle: item.responseTitle,
                  responseDesc: item.responseDesc,
                });
              }
              return acc;
            }, []);

            setCitiesOptions(filteredCities);
          }
        } catch (error) {
          console.log(error);
        }
      }, 300);
    }
  };

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    leadEmail: "",
    leadName: "",
    leadPhone: "",
    city: "",
    streetaddress: "",
    homeType: "",
    specificRequirements: "",
    meetingTime: null,
    leadLookingTo: "",
    buyerSincerity: "",
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitError(false);

    if (currentStep === 5) {
      resetForm({ values: initialValues, submitCount: 0 });
      setCurrentStep(1);
      return;
    }

    try {
      const data = {
        ...values,
        meetingTime: values?.meetingTime
          ? dayjs(values?.meetingTime).format("YYYY-MM-DDTHH:mm:ss.SSS")
          : "",
        address: userAddress || "",
        originUrl: windowUrl,
        category: "leadreferallGeneric",
        formType: config?.platformTitle || "",
        marketingSource: marketingSource || "",
      };
      const response = await axios.post(
        "https://config.needhome.ca/formconnector/sale2solddefault",
        data
      );
      if (response?.data?.result === 1) {
        window.scrollTo(0, 0);
        setCurrentStep(currentStep + 1);
        setSubmitError(false);

        if (isWhatsApp) {
          window.open(
            `https://api.whatsapp.com/send?phone=${
              config?.platformWhatsAppNumber
            }&amp;text=Hey ${config?.platformTitle}, My Name is ${
              values?.name || ""
            }. I am looking to Send you A Lead Referral. Can you connect with me As soon as possible.`,
            "_blank"
          );
        }

        if (phoneBtnClick) {
          window.location.href = `tel:${
            config?.platformPhoneNumber || "+16476490400"
          }`;
        }
      } else {
        setSubmitError(true);
      }
    } catch (error) {
      setSubmitError(true);
      console.error(error);
    } finally {
      setIsWhatsApp(false);
      setPhoneBtnClick(false);
      setSubmitting(false);
      resetForm({ values, submitCount: 0 });
    }
  };

  return (
    <div className="form_mainContainer">
      <div className="agent_profile d-flex align-items-center gap-3">
        <img
          src="https://config.assignmentsold.ca/Attachments/Newhomez-Agent-Profile.jpg"
          alt="Agent-Profle"
        />
        <div>
          <h3 className="agent_name m-0">
            {config?.platformTitle || "Sale2Sold"}
          </h3>
          <p className="agent_category">Listing Agent</p>
        </div>
      </div>
      <div className="form_container">
        <Formik
          initialValues={initialValues}
          validationSchema={
            currentStep === 1
              ? SellerStep1Schema
              : currentStep === 4
              ? SellerStep5Schema
              : null
          }
          onSubmit={handleSubmit}
        >
          {({
            isSubmitting,
            errors,
            handleChange,
            handleBlur,
            values,
            submitCount,
            submitForm,
            setFieldValue,
          }) => (
            <Form className="w-100 gap-3 mt-4 d-flex flex-column">
              <AutoFocusError />

              {currentStep === 1 && (
                <FormFirstSlide
                  values={values}
                  errors={errors}
                  submitCount={submitCount}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                />
              )}

              {currentStep === 2 && (
                <>
                  <p className="label_heading mb-0 leads_heading">
                    Lead Details (That you know of)
                  </p>

                  <div>
                    <p className="label_heading">What's their Name?</p>
                    <MDTextInput
                      label="Enter Name"
                      name="leadName"
                      value={values.leadName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.leadName)}
                      helperText={submitCount > 0 && errors.leadName}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">What's their Email?</p>
                    <MDTextInput
                      label="Enter Email"
                      name="leadEmail"
                      value={values.leadEmail}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.leadEmail)}
                      helperText={submitCount > 0 && errors.leadEmail}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">What's their Phone Number?</p>
                    <MDPhoneInput
                      name="leadPhone"
                      value={values.leadPhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.leadPhone)}
                      helperText={submitCount > 0 && errors.leadPhone}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      What's their Street Address?
                    </p>

                    <MDAutoComplete
                      options={addressOptions?.map((b) => b?.responseDesc)}
                      value={values.streetaddress}
                      onChange={(event, newValue) => {
                        setFieldValue("streetaddress", newValue);
                      }}
                      onInputChange={handleAddressChange}
                      error={submitCount > 0 && Boolean(errors.streetaddress)}
                      helperText={submitCount > 0 && errors.streetaddress}
                      label="Enter Street Address"
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      What City are they located in?
                    </p>

                    <MDAutoComplete
                      options={citiesOptions?.map((b) => b?.responseTitle)}
                      value={values.city}
                      onChange={(event, newValue) => {
                        setFieldValue("city", newValue);
                      }}
                      onInputChange={handleCityChange}
                      error={submitCount > 0 && Boolean(errors.city)}
                      helperText={submitCount > 0 && errors.city}
                      label="Enter City"
                      fullWidth
                    />
                  </div>
                </>
              )}

              {currentStep === 3 && (
                <>
                  <p className="label_heading mb-0 leads_heading">
                    Lead Details (That you know of)
                  </p>
                  <div>
                    <p className="label_heading">Lead is looking to</p>
                    <MDSelectInput
                      label="Select"
                      name="leadLookingTo"
                      value={values.leadLookingTo}
                      options={leadsLookingOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.leadLookingTo)}
                      helperText={submitCount > 0 && errors.leadLookingTo}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      Do you know how serious they are?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="buyerSincerity"
                      value={values.buyerSincerity}
                      options={buyerSincerityOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.buyerSincerity)}
                      helperText={submitCount > 0 && errors.buyerSincerity}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">What type of Home?</p>
                    <MDSelectInput
                      label="Select"
                      name="homeType"
                      value={values.homeType}
                      options={buyerHomeTypeOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.homeType)}
                      helperText={submitCount > 0 && errors.homeType}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      Do you know any other requirements? (Such as price, or
                      bed/bath)
                    </p>
                    <MDTextInput
                      label="Enter here"
                      name="specificRequirements"
                      value={values.specificRequirements}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        submitCount > 0 && Boolean(errors.specificRequirements)
                      }
                      helperText={
                        submitCount > 0 && errors.specificRequirements
                      }
                      fullWidth
                      multiline
                      rows={3}
                    />
                  </div>
                </>
              )}

              {currentStep === 4 && (
                <>
                  <MDDateAndTimePicker
                    label="Choose Date and Time"
                    value={values?.meetingTime}
                    onChange={(newValue) => {
                      setFieldValue("meetingTime", newValue);
                    }}
                    error={submitCount > 0 && Boolean(errors.meetingTime)}
                    helperText={submitCount > 0 && errors.meetingTime}
                  />
                </>
              )}

              {currentStep === 5 && (
                <LeadReferralGenericThanks
                  userName={values.name}
                  phoneNumber={values.phone}
                  dateTime={values.meetingTime}
                />
              )}

              {submitError && (
                <p className="error_message m-0">
                  Error Submiting Form. Kindly submit again۔
                </p>
              )}

              <div
                className="w-100 d-flex align-item gap-3
              flex-wrap"
              >
                <button
                  type="submit"
                  className={`submit_button next_button ${
                    isSubmitting ? "disabled_btn" : ""
                  } ${currentStep === 4 ? "mbl_nextbtn" : ""} ${
                    currentStep === 5 ? "w-100" : ""
                  }`}
                  disabled={isSubmitting}
                >
                  {currentStep === 6
                    ? "Submit"
                    : currentStep === 5
                    ? "Add More Referral Leads"
                    : currentStep === 4
                    ? "Submit Lead"
                    : "Next"}
                </button>

                {currentStep !== 5 && (
                  <button
                    type="button"
                    className={`submit_button call_button 
                       ${isSubmitting ? "disabled_btn" : ""}
                      ${currentStep === 4 ? "mbl_callbtn" : ""}`}
                    disabled={isSubmitting}
                    onClick={() => {
                      submitForm();
                      setPhoneBtnClick(true);
                    }}
                  >
                    Call
                  </button>
                )}
              </div>

              {currentStep !== 5 && (
                <button
                  className={`Send_btn whatsApp_btn  ${
                    isSubmitting ? "disabled_btn" : ""
                  }`}
                  id="whatsApp_btn"
                  type="button"
                  disabled={isSubmitting}
                  onClick={() => {
                    setIsWhatsApp(true);
                    submitForm();
                  }}
                >
                  <img
                    src="https://config.assignmentsold.ca/attachments/newhomez-email/logos_whatsapp-icon.png"
                    alt="whatsapp_logo"
                  />
                  WhatsApp
                </button>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default LeadReferralRewardsGenericForm;
